// Vue plugin <eui-positionerad-panelcontainer>:

import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
import euiDragAndDropEvents from 'v-directives/euiDragAndDropEvents';
import { coordinatesIntersectWithRect } from 'CoordinatesIntersectWithRect';


// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-positionerad-panelcontainer',

	//:style="{ width:vpItem.w * 80 + 'px', height:vpItem.h * 80 + 'px', top:vpItem.y * 80 + 'px', left:vpItem.x * 80 + 'px', padding:this.$parent.vpGap / 2 + 'px'}"
	//style="position:absolute; top:0; left:0;"
	//:style="{ width:vpItem.w * 80 + 'px', height:vpItem.h * 80 + 'px', transform:'translate3d(' + vpItem.x * 80 + 'px, ' + vpItem.y * 80 + 'px, 0)', padding:this.$parent.vpGap / 2 + 'px'}"

	// Event kan inte detekteras så här om inte div:en har tabindex: @keyup.esc="window.console.log('Esc tryckt!');" tabindex="0"
	// Alt lösning vald, se mounted nedan.
	template: `
		<div class="_eui-ppc"
			v-drag-and-drop-events="{ listening: vpDragAndDropAktiverad, eventHandler: (e) => onDragAndDrop(e) }"
			:class="{ '-is-draggable':vpDragAndDropAktiverad, '-is-resizeable':vpDragAndDropAktiverad && !vpPreventResizing, '-is-beeing-moved':isBeeingMoved, '-is-beeing-resized':isBeeingResized, '-inaktiverad':skaVaraInaktiverad, '-osynlig':skaVaraOsynlig }"
			:disabled="skaVaraInaktiverad"
			:style="{
				order:vpOrder,
				width:vpWidth * vpGrid.x + 'px',
				height:vpHeight * vpGrid.y + 'px',
				padding:vpGap / 2 + 'px'
			}"
		>
			<slot></slot>

			<div v-if="!vpPreventResizing" class="_eui-ppc_resize-handle">
				<div class="_eui-ppc_resize-handle_backdrop"
					:style="{
						transform:'translate3d(' + -vpGap / 2 + 'px, ' + -vpGap / 2 + 'px, 0)',
					}"
				></div>

				<div class="_eui-ppc_resize-handle_icon"
					:style="{
						transform:'translate3d(' + -vpGap / 2 + 'px, ' + -vpGap / 2 + 'px, 0)',
					}"
				></div>
			</div>

		</div>
	`,

	mixins: [ euiLifecycleStatusesMixin ],

	directives: {
		[euiDragAndDropEvents.name]: euiDragAndDropEvents,
	},

	props: {
		vpGrid: {
			type: Object,
			required: true
		},
		vpGap: {
			type: Number,
			required: true
		},

		vpIndex: {				// Array-index under denna sidvisning. Oföränderligt vid flyttning av item. Korrelerar garanterat med panelytan-komponentens vpItems-array.
			type: Number,		// 0–n
			required: true
		},
		vpOrder: {
			type: Number,
			required: true
		},

		vpWidth: {					// Grid units! Obs! På panel-*containern*, inte på panelen (vpGap är inkluderat).
			type: Number,
			required: true
		},
		vpHeight: {					// Grid units! Obs! På panel-*containern*, inte på panelen (vpGap är inkluderat).
			type: Number,
			required: true
		},

		vpMinWidth: {					// Grid units! Obs! På panel-*containern*, inte på panelen (vpGap är inkluderat).
			type: Number,
			required: true
		},
		vpMinHeight: {					// Grid units! Obs! På panel-*containern*, inte på panelen (vpGap är inkluderat).
			type: Number,
			required: true
		},

		vpMaxWidth: {					// Grid units! Obs! På panel-*containern*, inte på panelen (vpGap är inkluderat).
			type: Number,
			required: true
		},
		vpMaxHeight: {					// Grid units! Obs! På panel-*containern*, inte på panelen (vpGap är inkluderat).
			type: Number,
			required: true
		},

		vpPreventResizing: {
			type: Boolean,
			default: false
		},

		vpDragAndDropAktiverad: {
			type: Boolean,
			default: false
		},
		// Prop som härstammar reaktivt från parent, alltså panelytan:
		vpPanelytansDimensionerOchPositioner: {
			type: Object,
			required: true
		},

		// Standard-props:
		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			uniktId: 'eui-positionerad-panelcontainer-unikt-' + (++uniktIdCounter),

			draggingIsMove: null,		// Typ av drag. true = "Move", false = "Resize".

			draggingFromMouseCenter: { x: 0, y: 0 },
			draggingFromElementPosition: { x: 0, y: 0 },		// 'offset' = "outer".
			draggingFromElClientRect: null,
			dragHandleEl: null,		// DOM element

			resizeHandleEl: null,		// bara om resizing *inte* är förhindrat
		};
	},

	computed: {
		isBeeingMoved() {
			return (this.dragHandleEl !== null && this.draggingIsMove);
		},

		isBeeingResized() {
			return (this.dragHandleEl !== null && !this.draggingIsMove);
		},

		draggingFromMouseCenterRelativeToElPosition() {
			if (this.draggingFromElClientRect === null)
				return null;

			let x = this.draggingFromMouseCenter.x - this.draggingFromElClientRect.x;
			let y = this.draggingFromMouseCenter.y - this.draggingFromElClientRect.y;
			return { x, y };
		},

		draggingFromPanelcontainernsBredd() {
			return this.draggingFromElClientRect.width;
		},
		draggingFromPanelcontainernsHojd() {
			return this.draggingFromElClientRect.height;
		},

		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedAndNextTickHasOccured);	//AndSecondNextTickHasOccured);
		},
		skaVaraInaktiverad() {
			return (this.vpInaktiverad);	// || this.vpDragAndDropAktiverad);	// || !this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured);
		},
	},

	methods: {
		flyttaEllerSkalaDragHandleEnligtHammerEvent(e, draggingIsMove) {
			let deltaX = e.deltaX;
			let deltaY = e.deltaY;

			// Vid dessa begränsningar struntar vi i att padding kan finnas, som egentligen begränsar disponiber yta ännu mer. Då slipper vi en tidsödande (?) gettning av computedStyle. *Dock* blir det fult om en vertikal rullningslist visas som "overlay", så här förutsätter vi lite fräckt att en sådan kan visas + att panelytan har en padding för detta i högerkant och minskar gränsen (i högerkant) med fast värde för att ta höjd för det  :/

			if (draggingIsMove)
			{
				// Om elementet ska flyttas:
				// Fixa dragHandle-elementet:

				//+ this.vpPanelytansDimensionerOchPositioner.scroll.left
				if (this.draggingFromElementPosition.x + deltaX < 0)
					deltaX = -this.draggingFromElementPosition.x;

				// + this.vpPanelytansDimensionerOchPositioner.scroll.top
				if (this.draggingFromElementPosition.y + deltaY < 0)
					deltaY = -this.draggingFromElementPosition.y;

				let maxX = this.vpPanelytansDimensionerOchPositioner.scroll.width - this.draggingFromPanelcontainernsBredd - 18;	// -18: Se kommentar oavn.
				let maxY = this.vpPanelytansDimensionerOchPositioner.scroll.height - this.draggingFromPanelcontainernsHojd;

				if (this.draggingFromElementPosition.x + deltaX > maxX)
					deltaX = maxX - this.draggingFromElementPosition.x;

				if (this.draggingFromElementPosition.y + deltaY > maxY)
					deltaY = maxY - this.draggingFromElementPosition.y;

				this.dragHandleEl.style.transform = `translate3d(${deltaX}px,${deltaY}px,0)`;

				// Returnera att platsen har ändrats:
				// Styr om panmove-eventet ska bubbla uppåt till panelytan eller inte. Vid "flytta" ska det alltid bubbla uppåt eftersom det är panelytan-komponenten som hanterar ev omflyttningar av enskilda positionerade panelcontainers:
				return true;
			}
			else
			{
				// Annars ska elementet skalas om:

				// Nya dimensioner enligt drag:

				let draggedToWidth = this.draggingFromPanelcontainernsBredd + deltaX;
				let draggedToHeight = this.draggingFromPanelcontainernsHojd + deltaY;

				// Fixa dragHandle-elementet:
				//// Applicera grid-storleken 1x1 som min och ingen gräns för max:
				//this.dragHandleEl.style.width = Math.max(this.vpGrid.x * 2, draggedToWidth) + 'px';
				//this.dragHandleEl.style.height = Math.max(this.vpGrid.y * 2, draggedToHeight) + 'px';	// vpGrid.y * 2 för annars blir den mindre än minimistorleken på panel (huvud med &nbsp; + tom kropp). Enklaste fixen ;)  Och för konsistens, samma *2 på bredden.
				// Applicera samma min/max som nedan:
				this.dragHandleEl.style.width = Math.max(this.vpMinWidth * this.vpGrid.x, Math.min(this.vpMaxWidth * this.vpGrid.x, draggedToWidth)) + 'px';
				this.dragHandleEl.style.height = Math.max(this.vpMinHeight * this.vpGrid.y, Math.min(this.vpMaxHeight * this.vpGrid.y, draggedToHeight)) + 'px';

				// Fixa vid behov själva elementet:
				let currentWidth = this.$el.style.width.replace('px', '') * 1;
				let currentHeight = this.$el.style.height.replace('px', '') * 1;

				// Snappa till grid + begränsa till min/max:
				let snapToGridWidth = Math.max(this.vpMinWidth, Math.min(this.vpMaxWidth, Math.round(draggedToWidth / this.vpGrid.x))) * this.vpGrid.x;
				let snapToGridHeight = Math.max(this.vpMinHeight, Math.min(this.vpMaxHeight, Math.round(draggedToHeight / this.vpGrid.y))) * this.vpGrid.y;

				if (snapToGridWidth !== currentWidth
					|| snapToGridHeight !== currentHeight)
				{
					// Om storleken ska ändras:
					this.$el.style.width = snapToGridWidth + 'px';
					this.$el.style.height = snapToGridHeight + 'px';
					// Returnera att storleken på den *positionerade panelcontainern* har ändrats:
					// Styr om panmove-eventet ska bubbla uppåt till panelytan eller inte. Vid "ändra storlek" ska det bara ske om panelcontainerns storlek verkligen ändrats (snappat till nya grid-units) eftersom storleksändringar i övrigt hanteras internt i denna komponent:
					return true;
				}
				else
				{
					// Returnera att storleken på den *positionerade panelcontainern* *inte* har ändrats:
					// Styr om panmove-eventet ska bubbla uppåt till panelytan eller inte. Vid "ändra storlek" ska det bara ske om panelcontainerns storlek verkligen ändrats (snappat till nya grid-units) eftersom storleksändringar i övrigt hanteras internt i denna komponent:
					return false;
				}

			}
		},

		stoppaPagaendeDragginghantering() {
			// Ta bort och avveckla "drag handle":
			this.dragHandleEl.remove();	// Ta bort från DOM.
			this.dragHandleEl = null;

			// Sätt tillbaka cursorn (ta bort inline style):
			this.$el.style.cursor = '';
		},

		onDragAndDrop(e) {
			//if (e.type == 'panavbruten-custom')
			//{
			//	// panavbruten är ett *custom* special-Hammer-"event" *utan* andra properties än "type":
			//	console.log(`Dnd-containern: index: ${this.vpIndex}, order: ${this.vpOrder}, type: ${e.type}`, e);
			//}
			//else
			//{
			//	console.log(`Dnd-containern: index: ${this.vpIndex}, order: ${this.vpOrder}, eventType: ${e.eventType}, type: ${e.type}, x: ${e.deltaX}, y: ${e.deltaY}, drop: ${e.isFinal}`, e);
			//}

			// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
			// Obs! Då Hammer inte verkar klara att stoppa propagering av events till underliggande element/recognizers (se bl.a. https://github.com/josdejong/propagating-hammerjs) valde jag en lösning där jag *inte* använder två recognizers, en för resize-handle och en för drag-handle (hela panelcontainern). Istället bara en recognizer på panelcontainern och nedan separerar jag sedan ytan med resize-handle och övrig yta (= drag-handle):
			// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

			let eventName = null;
			//let event2Name = null;


			//if (e.eventType)
			switch (e.type) {
				case 'panstart':
				case 'panstart-virtuellt-custom':
				{
					// Spara undan lite startdata:

					// Kolla det är ytan för resize-handle eller ytan för draghandle (hela elementet exkl drag-handle-ytan):
					this.draggingIsMove = true;	// Utgångsläge: "Move".

					if (!this.vpPreventResizing)
					{
						// Om det går att ändra storlek på panelcontainern:
						let resizeHandleRect = this.resizeHandleEl.getBoundingClientRect();

						if (coordinatesIntersectWithRect(e.center.x, e.center.y, resizeHandleRect))
						{
							// Om muspositionen är inom resize-handle-ytan:
							this.draggingIsMove = false;		// false = typ av drag är "Resize".
						}
					}

					this.draggingFromElClientRect = this.$el.getBoundingClientRect();

					this.draggingFromMouseCenter.x = e.center.x - e.deltaX;
					this.draggingFromMouseCenter.y = e.center.y - e.deltaY;

					this.draggingFromElementPosition.x = this.$el.offsetLeft;	// 'offsetX' = "outer", medan 'clientX' = inner med border och ev rulln.list borträknad.
					this.draggingFromElementPosition.y = this.$el.offsetTop;

					// Skapa ett "drag handle" = lite genomskinlig kopia av elementet:
					this.dragHandleEl = this.$el.cloneNode(true);	// True = deep clone.

					// Positionera det ovanpå det klonade elementet:
					this.dragHandleEl.style.zIndex = '2';
					this.dragHandleEl.style.position = 'absolute';

					this.dragHandleEl.style.left = this.draggingFromElementPosition.x
						+ this.vpPanelytansDimensionerOchPositioner.offset.left
						- this.vpPanelytansDimensionerOchPositioner.scroll.left + 'px';

					this.dragHandleEl.style.top = this.draggingFromElementPosition.y
						+ this.vpPanelytansDimensionerOchPositioner.offset.top
						- this.vpPanelytansDimensionerOchPositioner.scroll.top + 'px';

					// Styla det (via class)
					this.dragHandleEl.classList.add('-drag-handle');

					if (!this.draggingIsMove)
					{
						// Om det är resize:
						// Ta bort allt innehåll i panelens huvud resp kropp:
						// Obs! Förutsätter att varje panelcontainer innehåller just en <eui-panel> med (ev) huvud + kropp!

						var huvud = this.dragHandleEl.querySelector('._eui-panel_huvud');
						if (huvud)
						{
							huvud.innerHTML = '&nbsp;';		// Ej tom, för att höjden ska bli rätt! Samma problem uppstår om man stylear padding enl nedan :(
						}
						//huvud.style.padding = '3px';	// För att den ska kunna krympa till liten storlek, men ändå ha tillräcklig plats för att rundade hörn ska visas.

						var kropp = this.dragHandleEl.querySelector('._eui-panel_kropp');
						kropp.innerHTML = '';
						//kropp.style.padding = '3px';	// För att den ska kunna krympa till liten storlek, men ändå ha tillräcklig plats för att rundade hörn ska visas.

						// Styla det (via class)
						this.dragHandleEl.classList.add('-is-beeing-resized');
					}
					else
					{
						// Annars är det move:
						// Styla det (via class)
						this.dragHandleEl.classList.add('-is-beeing-moved');

					}


					// Injektera i DOM, omedelbart efter det som klonats:
					//this.$el.insertAdjacentElement('afterend', this.dragHandleEl);	// 'afterend': After the targetElement itself.
					// Obs! Numera $parent istället!!!!!
					this.$parent.$el.insertAdjacentElement('afterend', this.dragHandleEl);	// 'afterend': After the targetElement itself.

					// Flytta eller skala om "drag handle":
					this.flyttaEllerSkalaDragHandleEnligtHammerEvent(e, this.draggingIsMove);

					// Denna ger fel då någon sådan func inte finns (här, dessutom har den på annat ställe bytt namn till starta Escl..). Var fan kommer den ifrån och varför har jag inte märkt felet tidigare (console-fel)? Kanske en ofrivillig ctrl+v?
					//this.aktiveraEsclyssning();

					eventName = 'itemDraggingStarted';
					break;
				}

				case 'panmove':
				case 'panmove-virtuellt-custom':
				{
					// Flytta eller skala om "drag handle":
					let andrat = this.flyttaEllerSkalaDragHandleEnligtHammerEvent(e, this.draggingIsMove);

					if (andrat)
					{
						eventName = 'itemDragged';
						// Annars fortsätter den vara null och bubblr inte upp till panelytan nedan.
					}

					break;
				}

				// Hanterar inte pancancel. Den skickas i tid och otid och det är för mig oklart vad exakt den innebär!
				// Vid senare tester skickas den *inte* i tiod och otid (får den inte alls faktiskt). Viss extern exempelkod antyder att den inträffar när musen läm,nar objektet (man drar för snabbt) eller när musen lämnar containern/skärmen eller nåt sånt. Hanterar den tills vidare identiskt med det egna special-"eventet" panavbruten:
				case 'pancancel':
				case 'panavbruten-custom':
				{
					// panavbruten är ett *custom* special-Hammer-"event" *utan* andra properties än "type":

					if (!this.draggingIsMove)
					{
						// Om storleksändring pågick:
						// Återställ till storleken då storleksändringen inleddes:
						// (Då flyttning avbryts sker detta istället en nivå upp, i euiPanelyta.js.)

						this.$el.style.width = this.draggingFromPanelcontainernsBredd + 'px';
						this.$el.style.height = this.draggingFromPanelcontainernsHojd + 'px';
					}

					this.stoppaPagaendeDragginghantering();
					eventName = 'itemDraggingCanceled';
					break;
				}

				case 'panend':
				{
					this.stoppaPagaendeDragginghantering();
					eventName = 'itemDropped';

					break;
				}

				default:
				{
					console.error('Ogiltigt pan-event detekterat!');
				}
			}

			if (eventName)
			{
				// Skicka ett anpassat Vue-event till <eui-panelyta> (måste alltid vara "parent" till <eui-positionerad-panelcontainer>!):
				this.$parent.$emit(eventName, {
					positioneradPanelcontainer: this,		// ref till denna vue-komponent
					hammerEvent: e,
					arRepetition: false		// false = detta är *ingen* virtuell repetition
				});
			}
		},

	},

	created() {
		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Exempel: this.$_undertryckNastaAndradEvent = false;
	},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.
		//-----------------------------------------------------------------------------------------------------------------------
		// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
		//
		// 1. Mixins mounted hook.
		// 2. Appens/komponentens mounted hook.
		//
		// 3. Mixins mounted hook + nextTick (DOM not updated yet).
		// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
		//
		// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		//
		// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
		//
		// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
		// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
		// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
		//-----------------------------------------------------------------------------------------------------------------------

		//## 2. Appens/komponentens mounted hook:  #################################
		//console.log('2. Appens/komponentens mounted hook');

		if (!this.vpPreventResizing)
		{
			// bara om resizing *inte* är förhindrat:
			this.resizeHandleEl = this.$el.querySelector('._eui-ppc_resize-handle');
		}


		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//## 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet):  #################################
			//console.log('4. Appens/komponentens mounted hook + nextTick');
		});
	},
};
